<template>
	<div>
		<el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" class="margin_top_40"
			:wrapperClosable="false" :modal='false' :destroy-on-close='true'>
			<el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm" class="demo-form-inline"
				inline>
				<el-form-item label="业务编号" prop="code">
					<el-input class="input_200px" :disabled="isEdit" size="small" v-model="editForm.code"
						auto-complete="off" placeholder="请输入业务编号">
					</el-input>
				</el-form-item>
				<el-form-item label="业务名称" prop="name">
					<el-input class="input_200px" size="small" v-model="editForm.name" auto-complete="off"
						placeholder="请输入业务名称">
					</el-input>
				</el-form-item>
				<el-form-item label="业务类型" prop="businessConfigType">
					<el-select :disabled="isEdit" size="small" class="input_200px" v-model="editForm.businessConfigType"
						@change="configTypeChange" placeholder="请选择业务类型" filterable >
						<el-option v-for="item in businessTypeList" :key="item.keyId" :label="item.value"
							:value="Number(item.keyId)">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.businessConfigType === 3" label="业务值" prop="value">
					<el-select size="small" class="input_200px" v-model="editForm.value" placeholder="请选择业务值" filterable >
						<el-option v-for="item in valueTypeList" :key="item.keyId" :label="item.value"
							:value="item.keyId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.businessConfigType === 1" label="业务值" prop="value">
					<el-input class="input_200px" size="small" v-model="editForm.value" auto-complete="off"
						placeholder="请输入值">
					</el-input>
				</el-form-item>
				<el-form-item v-if="editForm.businessConfigType === 2" label="人员" prop="value">
					<el-select size="small" class="input_200px" v-model="editForm.value" multiple filterable  placeholder="请选择">
						<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.businessConfigType === 4" label="部门/班组" prop="echoContent">
					<el-cascader size="small" v-model="editForm.echoContent" :options="deptData" class="input_200px"
						:props="{
							expandTrigger: 'hover',
							label: 'name',
							value: 'keyId',
							children: 'subList',
							checkStrictly: true,
							multiple: true 
						}" @change="handleChange" collapse-tags :clearable="true" :show-all-levels="false">
					</el-cascader>
				</el-form-item>
				<el-form-item v-if="editForm.businessConfigType === 5" label="角色" prop="value">
					<el-select size="small" class="input_200px" v-model="editForm.value" multiple placeholder="请选择">
						<el-option v-for="item in roleList" :key="item.keyId" :label="item.value" :value="item.keyId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业务描述" prop="descrption">
					<el-input class="input_200px" type="textarea" :rows="6" size="small" v-model="editForm.descrption"
						placeholder="请输入业务描述"></el-input>
				</el-form-item>
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title"
					@click="submitForm('editForm')">
					保存
				</el-button>
				<!-- <el-button :disabled="editForm.keyId === ''" size="small" :loading="saveloading" class="title"
					@click="deleteMenu">
					删除
				</el-button> -->
			</div>
		</el-drawer>
	</div>
</template>
<script>
	import {
		GetSystemBusinessConfigDetail,
		SaveSystemBusinessConfig,
		DelSystemBusinessConfig
	} from '../../../api/systemApi.js';
	import {
		GetEnumConfigDropListByCode
	} from '../../../api/enumApi.js';
	import {
		GetUserInfoDropList,
		GetRoleDropList
	} from "../../../api/userApi.js";
	import {
		GetOrganizationTreeList,
	} from '../../../api/organizationalApi.js'
	export default {
		data() {
			return {
				saveloading: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				title: '新增',
				// 编辑表单
				editForm: {
					keyId: "",
					code: '',
					name: "",
					value: '',
					businessConfigType: 1,
					descrption: '',
					echoContent: ''
				},
				businessTypeList: [],
				rules: {
					code: [{
						required: true,
						message: "请输入业务编号",
						trigger: "blur",
					}, ],
					name: [{
						required: true,
						message: "请输入业务名称",
						trigger: "blur",
					}, ],
				},
				userList: [],
				roleList: [],
				valueTypeList: [],
				deptData: [],
				isEdit: false,
				deptOrTaem: []
			};
		},
		components: {},
		created() {},
		methods: {

			// change事件
			handleChange(value) {
				this.editForm.value = [];
				this.editForm.echoContent = value;
				value.forEach((item) => {
					this.editForm.value.push(item[item.length - 1])
				})
			},
			//显示编辑界面
			editShow(row) {
				this.getOrganizationTreeListData();
				this.getEnumConfigDropListByCode();
				this.getUserList();
				this.getRoleDropList();
				if (row != undefined && row != 'undefined') {
					this.title = '编辑';
					this.isEdit = true;
					let parameter = {
						keyId: row.keyId,
					};
					this.getDetail(parameter)
				} else {
					this.title = '新增';
					this.isEdit = false;
					this.fileList = [];
					this.$data.editForm = this.$options.data.call(this).editForm
					this.editFormVisible = true;
				}
			},

			// 删除
			deleteMenu() {
				this.$confirm('确定要删除<' + this.editForm.name + '>吗?', '信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					let parmter = {
						keyId: this.editForm.keyId
					};
					DelSystemBusinessConfig(parmter)
						.then((res) => {
							if ((res.code === 1)) {
								this.$message({
									type: 'success',
									message: '已删除!',
								});
								this.editFormVisible = false
								this.$parent.getListData()
							} else {
								this.$message({
									type: 'info',
									message: res.msg,
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error('删除失败，请稍后再试！');
						});
				});
			},

			// 详情
			getDetail(param) {
				const that = this;
				GetSystemBusinessConfigDetail(param)
					.then((res) => {
						if (res.code === 1) {
							that.editForm = res.data;
							if (that.editForm.businessConfigType === 2 || that.editForm.businessConfigType === 5) {
								let tempValue = []
								if (res.data.value) {
									if (that.editForm.value.indexOf(',') != -1) {
										tempValue = that.editForm.value.split(",");
									} else {
										tempValue.push(res.data.value)
									}
									that.editForm.value = tempValue
								} else {
									that.editForm.value = []
								}
							} else if (that.editForm.businessConfigType === 4) {
								let tempValue = []
								if (that.editForm.value) {
									that.editForm.echoContent = JSON.parse(that.editForm.echoContent)
								} else {
									that.editForm.value = ''
									that.editForm.echoContent = []
								}
							} else if (that.editForm.businessConfigType === 3) {
								that.getValueDropListByCode(that.editForm.code);
							}
							that.editFormVisible = true;
						} else {
							that.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},

			//获取组织架构下拉
			getOrganizationTreeListData() {
				let param = {
					parentId: ''
				}
				GetOrganizationTreeList(param)
					.then((res) => {
						if (res.code == 1) {
							this.deptData = this.recursion(res.data)
						} else {
							this.$message.error(res.msg);
						}
					}).catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},
			// 递归删除空子节点（数据字典）
			recursion(data) {
				data.forEach(item => {
					if (item.subList && item.subList.length > 0) {
						return this.recursion(item.subList)
					} else {
						delete item.subList
					}
				})
				return data
			},

			// 获取业务配置类型
			getEnumConfigDropListByCode() {
				let param = {
					code: 'BusinessConfigType'
				}
				GetEnumConfigDropListByCode(param)
					.then((res) => {
						if (res.code === 1) {
							this.businessTypeList = res.data;
						}
					})
					.catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},

			// 获取枚举
			getValueDropListByCode(code) {
				let param = {
					code: code
				}
				GetEnumConfigDropListByCode(param)
					.then((res) => {
						if (res.code === 1) {
							this.valueTypeList = res.data;
						}
					})
					.catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},

			// 获取人员列表
			getUserList() {
				GetUserInfoDropList()
					.then((res) => {
						this.userList = res.data
					})
					.catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},

			// 获取角色下拉
			getRoleDropList() {
				GetRoleDropList()
					.then((res) => {
						this.roleList = res.data
					})
					.catch((err) => {
						this.$message.error('加载失败，请稍后再试！');
					});
			},

			// 类型变化
			configTypeChange() {
				this.editForm.echoContent = '';
				if (this.editForm.businessConfigType === 2 || this.editForm.businessConfigType === 4 || this.editForm
					.businessConfigType === 5) {
					this.editForm.value = [];
				} else if (this.editForm.businessConfigType === 2) {
					this.editForm.value = '';
				} else if (this.editForm.businessConfigType === 3) {
					this.editForm.value = '';
					this.getValueDropListByCode(this.editForm.code);
				}
			},

			// 编辑、增加页面保存方法
			submitForm(editData) {
				const that = this;
				this.$refs[editData].validate((valid) => {
					if (valid) {
						this.saveloading = true;
						if (this.editForm.businessConfigType === 2 || this.editForm.businessConfigType === 5) {
							if (that.editForm.value.length > 0) {
								that.editForm.value = that.editForm.value.toString();
							} else {
								that.editForm.value = ''
							}
						} else if (this.editForm.businessConfigType === 4) {
							if (that.editForm.echoContent.length > 0) {
								that.editForm.echoContent = JSON.stringify(that.editForm.echoContent);
								that.editForm.value = that.editForm.value.toString();
							} else {
								that.editForm.value = ''
								that.editForm.echoContent = [];
							}
						}
						// return
						SaveSystemBusinessConfig(that.editForm)
							.then((res) => {
								if (res.code == 1) {
									this.editFormVisible = false;
									this.$parent.getListData();
									this.$message({
										type: 'success',
										message: '保存成功！',
									});
									this.saveloading = false;
								} else {
									this.$message({
										type: 'info',
										message: res.msg,
									});
									this.saveloading = false;
								}
							})
							.catch((err) => {
								this.editFormVisible = false;
								this.saveloading = false;
								this.$message.error('保存失败，请稍后再试！');
							});
					} else {
						return false;
					}
				});
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.saveloading = false;
				this.editFormVisible = false;
				this.$refs['editForm'].resetFields();
			},

		},
	};
</script>
<style scoped>
</style>